<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      :shipmentCode="shipmentCode"
      :shipmentStatus="shipmentStatus"
      @reload="getData"
      @submitDel="submitDel"
      @openEditDialog="openEditDialog"
      @detail="openBookingDesc"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        :shipmentStatus="shipmentStatus"
        @openEditBaseDialog="openEditBaseDialog"
        @batchDel="batchDel"
        @openBatchEditDialog="openBatchEditDialog"
      />
    </page-main>

    <BaseBookingEditDialog
      :visible.sync="baseBookingEditDialogOptions.visible"
      :title="baseBookingEditDialogOptions.title"
      :shipmentBookingCode="baseBookingEditDialogOptions.code"
      :shipmentCode="shipmentCode"
      :shipmentStatus="shipmentStatus"
      @reload="getData"
    />

    <CustomsBookingEditDialog
      :visible.sync="customsBookingEditDialogOptions.visible"
      :title="customsBookingEditDialogOptions.title"
      :shipmentBookingCode="customsBookingEditDialogOptions.code"
      :custCode="customsBookingEditDialogOptions.custCode"
      :shipmentCode="shipmentCode"
      :shipmentStatus="shipmentStatus"
      @reload="getData"
    />

    <BatchEditBaseBookingDialog
      :visible.sync="batchEditBaseBookingDialogOptions.visible"
      :title="batchEditBaseBookingDialogOptions.title"
      :shipmentBookingCodeList="batchEditBaseBookingDialogOptions.listCode"
      :custCode="batchEditBaseBookingDialogOptions.custCode"
      :shipmentCode="shipmentCode"
      :shipmentStatus="shipmentStatus"
      @reload="getData"
    />

    <BatchEditCustomsBookingDialog
      :visible.sync="batchEditCustomsBookingDialogOptions.visible"
      :title="batchEditCustomsBookingDialogOptions.title"
      :shipmentBookingCodeList="batchEditCustomsBookingDialogOptions.listCode"
      :custCode="batchEditCustomsBookingDialogOptions.custCode"
      :shipmentCode="shipmentCode"
      :shipmentStatus="shipmentStatus"
      @reload="getData"
    />

    <BookingDescriptions
      :visible.sync="bookingDescOpts.visible"
      :shipmentCode="bookingDescOpts.shipmentCode"
      :shipmentBookingCode="bookingDescOpts.shipmentBookingCode"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import BaseBookingEditDialog from '../base-booking-edit/dialog'
import CustomsBookingEditDialog from '../customs-booking-edit/dialog'
import BatchEditBaseBookingDialog from '../batch-edit-base-booking/dialog.vue'
import BatchEditCustomsBookingDialog from '../batch-edit-customs-booking/dialog.vue'
import BookingDescriptions from '../booking-descriptions'
export default {
  components: {
    PageHeader,
    PageMain,
    BaseBookingEditDialog,
    CustomsBookingEditDialog,
    BatchEditBaseBookingDialog,
    BatchEditCustomsBookingDialog,
    BookingDescriptions,
  },
  mixins: [BaseTable, EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    shipmentStatus: { type: String, default: '' },
  },
  data() {
    return {
      baseBookingEditDialogOptions: {
        visible: false,
        code: '',
        title: '',
      },
      customsBookingEditDialogOptions: {
        visible: false,
        code: '',
        title: '',
      },
      batchEditBaseBookingDialogOptions: {
        visible: false,
        title: '',
        listCode: [],
        custCode: '',
      },
      batchEditCustomsBookingDialogOptions: {
        visible: false,
        title: '',
        listCode: [],
        custCode: '',
      },
      bookingDescOpts: {
        visible: false,
        shipmentCode: '',
        shipmentBookingCode: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$api
        .shipmentBookingListApi({
          shipmentCode: this.shipmentCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    submitDel(shipmentBookingCodeList) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .shipmentBookingDelApi({
            shipmentBookingCodeList,
            shipmentCode: this.shipmentCode,
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getData()
          })
      })
    },
    batchDel() {
      const data = this.$refs.main.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }
      const listCode = data.map((t) => t.shipmentBookingCode)
      this.submitDel(listCode)
    },
    openEditBaseDialog({ type, params = {} }) {
      const types = {
        edit:
          this.$l('INDEX.dialog_title_edit_booking_information') ||
          '编辑订舱信息',
        add:
          this.$l('INDEX.dialog_title_add_booking_information') ||
          '添加订舱信息',
      }
      this.baseBookingEditDialogOptions = {
        visible: true,
        title: types[type],
        code: params.code,
      }
    },
    openEditDialog({ shipmentBookingCode: code, custCode }) {
      if ('B' === this.shipmentStatus) {
        this.openEditBaseDialog({ type: 'edit', params: { code } })
        return
      }
      this.customsBookingEditDialogOptions = {
        visible: true,
        title:
          this.$l('INDEX.dialog_title_edit_booking_information') ||
          '编辑订舱信息',
        code: code,
        custCode,
      }
    },
    openBatchEditDialog() {
      const data = this.$refs.main.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据!',
          type: 'warning',
        })
        return
      }
      const listCode = data.map((item) => item.shipmentBookingCode)
      const custCode = data[0].custCode

      if ('B' === this.shipmentStatus) {
        this.batchEditBaseBookingDialogOptions = {
          visible: true,
          title: '批量更新',
          listCode,
          custCode,
        }
        return
      }
      this.batchEditCustomsBookingDialogOptions = {
        visible: true,
        title: '批量更新',
        listCode,
        custCode,
      }
    },
    openBookingDesc({ shipmentBookingCode, shipmentCode }) {
      this.bookingDescOpts = {
        visible: true,
        shipmentCode,
        shipmentBookingCode,
      }
    },
  },
}
</script>
